// sidebar.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private isSidebarExpandedSubject = new BehaviorSubject<boolean>(true);
  isSidebarExpanded$ = this.isSidebarExpandedSubject.asObservable();

  toggleSidebar() {
    this.isSidebarExpandedSubject.next(!this.isSidebarExpandedSubject.value);
  }

  setSidebarState(state: boolean) {
    this.isSidebarExpandedSubject.next(state);
  }
}
